function LandingIntro() {
  return (
    <div className="hero min-h-full rounded-l-xl bg-base-200">
      <div className="hero-content py-12">
        <div className="max-w-md">
          <h1 className="text-center text-3xl font-bold ">Bandwagon</h1>
          <div className="mt-12 text-center">
            <img
              src="./logo192.png"
              alt="Dashwind Admin Template"
              className="inline-block w-48 rounded"
            ></img>
          </div>
          <h1 className="mt-8 text-2xl font-bold">Crowd Collaboration</h1>
          <p className="mt-4 py-2">
            ✓ <span className="font-bold">Privacy first</span> share only what
            you want <span className="italic">(or nothing at all)</span>
          </p>
          <p className="py-2 ">
            ✓ <span className="font-bold">Connect with</span> your
            community/event/venue/friends/team
          </p>
          <p className="py-2">
            ✓ <span className="font-bold">Get Notified </span>
            <span className="italic">(but on your terms)</span>
          </p>
          <p className="py-2 ">
            ✓{" "}
            <span className="font-semibold">
              Calendars, Announcements, Messages, Polling
            </span>
          </p>
          <p className="mb-4 py-2">
            ✓ <span className="font-bold">Join/leave </span>{" "}
            <span className="italic">(with nothing left behind)</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default LandingIntro;
